<template>
<div class="parent_div" id="dc_customize">
  <dd-header />
  <div class="wrapper"><!-- <div class="container"> -->
    <div class="main_content">
      <dd-menu ref="menuRef"/>
      <div class="row">
        <dd-sitemap
          :pageKey="pageKey"
          :pageList="pageList"
          :mapStyle="'topic_path'"
        />
        <div class="col-lg-9 order-lg-2">
          <div id="series">
            <div id="manufacturer" class="mb-2">ドゥーマンズ株式会社</div>
            <div class="series_title2">パーソナルシェルフ</div>
            <div class="kv">
              <dd-banner
                ref="ddBannerListRef"
                :swipeList="seriesList"
                :swiperOptions="categoryOptions"
                :horizontalMode="false"
              />
              <p>
                ライフスタイルに合わせた自由なカスタマイズ。さまざまな空間にマッチ。<br>
                ドライバーなどの工具は一切不要。組立て後は部品が見えない完成度。<br>
                厚み30mmの強度、耐荷重性能。国内生産の高い品質管理基準。
              </p>
            </div>
            <div class="series_content_title">おすすめの商品</div>
            <div class="recommend_wrap">
              <dd-product
                ref="ddCategoryListRef"
                :swipeList="productListReturn"
                :swiperOptions="productOptions"
                :horizontalMode="false"
                @clickImage="selectProduct"
              />
            </div>
          </div><!-- /#series -->
          <div id="introduction1" class="mt-5 series_content">
            <div class="series_title">パーソナルシェルフの特徴</div>
            <div class="row">
              <div v-for="(content, index) in contentList" :key="'series1_ct_' + index" class="col-sm-6 mb-3 sc_main_content">
                <template v-if="content.isVideo">
                  <iframe width="560" height="225" :src="content.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  <div>
                    <div>{{content.title}}</div>
                    <p>{{content.body}}</p>
                  </div>
                </template>
                <template v-else>
                  <img :src="content.img" alt="">
                  <div>
                    <div>{{content.title}}</div>
                    <p>{{content.body}}</p>
                  </div>
                </template>
              </div>
            </div>
          </div><!-- /#introduction1 -->
          <div id="introduction2" class="mt-5 series_content">
            <div class="series_title">簡単な組立て方法の動画を見る 実証！驚きの速さ！驚きの精度</div>
            <div class="row">
              <div v-for="(content, index) in constructList2" :key="'series2_ct_' + index" class="col-sm-6 mb-3 sc_main_content2">
                <template v-if="content.isVideo">
                  <iframe width="560" height="225" :src="content.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  <div>
                    <div>{{content.title}}</div>
                    <p>{{content.body}}</p>
                  </div>
                </template>
                <template v-else>
                  <img :src="content.img" alt="">
                  <div>
                    <div>{{content.title}}</div>
                    <p>{{content.body}}</p>
                  </div>
                </template>
              </div>
            </div>
          </div><!-- /#introduction2 -->
          <!-- <div id="introduction2" class="mt-5">
              <h2>タイトル</h2>
              <div class="row">
                  <div class="col-sm-6 mb-3">
                      <img :src="getImage('series/1/introduction2a.webp')" alt="">
                  </div>
                  <div class="col-sm-6 mb-3">
                      <h3>紹介コンテンツ</h3>
                      <p>この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。</p>
                  </div>
                  <div class="col-sm-6 mb-3">
                      <img :src="getImage('series/1/introduction2a.webp')" alt="">
                  </div>
                  <div class="col-sm-6 mb-3">
                      <h3>紹介コンテンツ</h3>
                      <p>この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。</p>
                  </div>
                  <div class="col-sm-6 mb-3">
                      <img :src="getImage('series/1/introduction2a.webp')" alt="">
                  </div>
                  <div class="col-sm-6 mb-3">
                      <h3>紹介コンテンツ</h3>
                      <p>この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。</p>
                  </div>
              </div>
          </div> -->
          <!-- /#introduction2 -->
          <div id="recommend" class="mt-5">
            <div class="series_content_title">新商品</div>
            <div class="recommend_wrap">
              <dd-product
                ref="ddCategoryListRef"
                :swipeList="productList"
                :swiperOptions="productOptions"
                :horizontalMode="false"
                @clickImage="selectProduct"
              />
            </div>
            <!-- <div class="text-center mb-4">
                <a class="btn btn-outline btn-sm" @click="route('DcCategory')">一覧へ</a>
            </div> -->
          </div><!-- /#recommend -->
          <div id="case" class="mt-5">
            <div class="series_content_title">施工事例</div>
            <div class="series_construct_list">
              <div v-for="(construct, index) in constructList" :key="'construct_' + index" class="col-sm-3 mb-3 case_wrap">
                <a @click="selectProduct(construct)"><img :src="construct.img" alt=""></a>
                <h3>{{construct.title}}</h3>
                <div class="product">{{construct.name}}</div>
              </div>
            </div>
          </div><!-- /#case -->

          <!-- <div id="instagram" class="mt-5">
          <h2 class="title_border">みんなの投稿＠Instagram</h2>
          <div class="row no-gutters">
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
              <div class="col-6 col-sm-3">
                  <a href=""><img :src="getImage('series/1/instagram1.webp')" alt=""></a>
              </div>
          </div>
          </div> -->
          <!-- /#instagram -->

          <!-- <div id="to_manufacturer">
            <div class="text-center m-5">
              <a class="btn btn-outline" href="">メーカー紹介ページへ</a>
            </div>
          </div> -->
          <!-- /#to_manufacturer -->
          <div class="detail_btn btn_pos_center" @click="route('DcSignUp')">会員登録はこちら 〉〉</div>
          <!-- /#foot_bn -->
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div>
  </div><!-- /.container -->
  <dd-footer />
  <!-- ローディングモーダル -->
  <dd-loading-modal ref="loadingModalRef" />
</div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import {DC_URL} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import DcBannerSwiper from '../components/common/DcBannerSwiper'
import DcProductSwiper from '../components/common/DcProductSwiper'

export default {
  name: 'DcSeriesPage',
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-product': DcProductSwiper,
    'dd-banner': DcBannerSwiper,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'DcSeriesPage',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'dcSeriesPage', key: 'DcSeriesPage', title: 'パーソナルシェルフ', route: 'DcSeriesPage'}
      ],
      categoryOptions: {
        slidesPerView: 'auto',
        slidesPrGroup: 2,
        slidesPerColumn: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true,
        centeredSlides: false,
        spaceBetween: 10,
        initialSlide: 0,
        loop: true,
        autoPlay: {
          delay: 2000,
          pauseOnMouseEnter: true
        }
      },
      productOptions: {
        slidesPerGroup: 1,
        slidesPerView: 4,
        spaceBetween: 10,
        initialSlide: 0,
        slidesPerColumn: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true,
        breakpoints: {
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 3,
            spaceBetween: 15
          },
          // when window width is >= 1024px
          1024: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        }
      },
      contentList: [
        {id: 1, img: this.getImage('series/1/point_01.png'), title: 'パーソナル デザイン', body: 'パターン、サイズ、色柄をクリックでセレクトするだけで簡単にあなたが求めるデザイン、サイズが実現します。設置場所のジャストサイズのカスタマイズにも対応。生活スタイルと、そのときのニーズに合った、あたなだけの収納、インテリアをお手頃価格で実現します'},
        {id: 2, img: this.getImage('series/1/point_02.png'), title: 'シンプルな組立てと、見えない部品', body: 'だれでも簡単に組み立てられ、強固な構造を画期的な組立方式のロックダボで実現した設計。組立後、部品が見えない構造が完成度を高め、あなたのデザインを損ねません。分解・追加もできるので、移設、追加など、予算に合わせたプランを考えることができます。'},
        {id: 3, img: this.getImage('series/1/point_03.png'), title: '品質とデザイン', body: '厚みはすべて30mm、耐荷重性、堅牢性など\n品質と性能、安心できるデザインを両立しています。表面は先進技術により木目をリアルに再現して、本物の質感と強度を備えています。'},
        {id: 4, img: '', title: '国内の信頼性', body: '国内の健康、環境に対する規制を保証する信頼の国内生産。ロックダボ加工の専用設備により 0.1mm単位の加工精度。日本の品質管理基準により高い信頼性を誇ります。', isVideo: true, url: 'https://www.youtube.com/embed/9ONeyCugeU8'},
        {id: 5, img: this.getImage('series/1/point_05.png'), title: 'オーダーシェルフ', body: '高さと奥行きを選択、幅を1mm単位で指定するだけで簡単にあなたが求めるデザイン、サイズを実現します。\n入力情報はそのまま工場にデータとして送られ、最短10営業日でお届けします。'},
        {id: 6, img: this.getImage('series/1/point_06.png'), title: '安心・安全 SDGs', body: '健康と環境に配慮した国内の各種規制を遵守\n同時に、環境・資源などの社会環境に照らし合わせた設計'}
      ],
      constructList2: [
        {id: 1, img: '', title: '【解説編】パーソナルシェルフ組立動画', body: 'この動画は、パーソナルシェルフの組立方法を解説します。 板と板をはめ合わせるだけ。工具もネジパーツも不要。 力いらずで簡単に組立てができる！', isVideo: true, url: 'https://www.youtube.com/embed/Qv2EppOmfco'},
        {id: 2, img: '', title: '【組立比較】パーソナルシェルフ 従来品', body: '3m50cmのパーソナルシェルフを何分で組み立てられるか、従来品と比較し、組み立てのスピードや簡単さを徹底検証しました！', isVideo: true, url: 'https://youtube.com/embed/58bB8dCgbx4'}
      ],
      seriesList: [
        {id: 1, img: this.getImage('series/1/TOP_01.png')},
        {id: 2, img: this.getImage('series/1/TOP_02.png')},
        {id: 3, img: this.getImage('series/1/TOP_03.png')},
        {id: 4, img: this.getImage('series/1/TOP_04.png')},
        {id: 5, img: this.getImage('series/1/TOP_05.png')},
        {id: 6, img: this.getImage('series/1/TOP_06.png')},
        {id: 7, img: this.getImage('series/1/TOP_07.png')},
        {id: 8, img: this.getImage('series/1/TOP_08.png')}
      ],
      productList: [
        {id: 3246, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/420_W2H2D280.webp'), name: '420シリーズW2H2D280', size: 'W:930mm\nH:752mm\nD:280mm'},
        {id: 3212, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/570_W3H2D280.webp'), name: '570シリーズW3H2D280', size: 'W:1830mm\nH:752mm\nD:280mm'},
        {id: 3217, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/870_W2H4D280.webp'), name: '870シリーズW2H4D280', size: 'W:1830mm\nH:1472mm\nD:280mm'},
        {id: 3236, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/330_W5H2D280.webp'), name: '330シリーズW5H2D280', size: 'W:1830mm\nH:752mm\nD:280mm'},
        {id: 3219, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/420_W3H3D280.webp'), name: '420シリーズW3H3D280', size: 'W:1380mm\nH:1112mm\nD:280mm'},
        {id: 3247, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/570_W2H2D280.webp'), name: '570シリーズW2H2D280', size: 'W:1230mm\nH:752mm\nD:280mm'}
      ],
      productListReturn: [
        {id: 3247, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/570_W2H2D280.webp'), name: '570シリーズW2H2D280', size: 'W:1230mm\nH:752mm\nD:280mm'},
        {id: 3219, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/420_W3H3D280.webp'), name: '420シリーズW3H3D280', size: 'W:1380mm\nH:1112mm\nD:280mm'},
        {id: 3236, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/330_W5H2D280.webp'), name: '330シリーズW5H2D280', size: 'W:1830mm\nH:752mm\nD:280mm'},
        {id: 3217, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/870_W2H4D280.webp'), name: '870シリーズW2H4D280', size: 'W:1830mm\nH:1472mm\nD:280mm'},
        {id: 3212, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/570_W3H2D280.webp'), name: '570シリーズW3H2D280', size: 'W:1830mm\nH:752mm\nD:280mm'},
        {id: 3246, ctype: 18, dtype: 2, img: this.getImage('top/series/domans/420_W2H2D280.webp'), name: '420シリーズW2H2D280', size: 'W:930mm\nH:752mm\nD:280mm'}
      ],
      constructList: [
        {id: 3232, ctype: 18, dtype: 2, img: this.getImage('series/1/construct/example_01.png'), title: '書斎', name: '570シリーズW3H5D280'},
        {id: 3207, ctype: 18, dtype: 2, img: this.getImage('series/1/construct/example_02.png'), title: 'リビング', name: '420シリーズW2H3D280'},
        {id: 3240, ctype: 18, dtype: 2, img: this.getImage('series/1/construct/example_03.png'), title: '洋間（寝室）', name: '330シリーズW4H4D280'},
        {id: 3219, ctype: 18, dtype: 2, img: this.getImage('series/1/construct/example_04.png'), title: '和室', name: '420シリーズW3H3D280'},
        {id: 3239, ctype: 18, dtype: 2, img: this.getImage('series/1/construct/example_05.png'), title: 'リビング（間仕切り）', name: '330シリーズW5H3D280 '},
        {id: 3212, ctype: 18, dtype: 2, img: this.getImage('series/1/construct/example_06.png'), title: 'ダイニング', name: '570シリーズW3H2D280'},
        {id: 3246, ctype: 18, dtype: 2, img: this.getImage('series/1/construct/example_07.png'), title: '洋間（子供部屋）', name: '420シリーズW2H2D280'},
        {id: 3236, ctype: 18, dtype: 2, img: this.getImage('series/1/construct/example_08.png'), title: 'リビング', name: '330シリーズW5H2D280'}
      ],
      swiperButtonPrev: {
        background: 'url(' + this.getImage('common/left.svg') + ') no-repeat center center / contain'
      },
      swiperButtonNext: {
        background: 'url(' + this.getImage('common/right.svg') + ') no-repeat center center / contain'
      }
    }
  },
  computed: {
  },
  methods: {
    series: function (sid) {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          seriesId: sid
        }
      }
      axios.get(DC_URL.TOP + '/series-info', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
          }
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        params: params
      })
    },
    selectProduct: function (obj) {
      this.$router.push({
        name: 'DcCustomize',
        query: {id: obj.id, ctype: obj.ctype, dtype: obj.dtype}
      })
    }
  },
  mounted () {
    this.series(this.$route.query.sid)
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-series.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSeriesPage.vue